module.exports = __webpack_public_path__ + "img/JOY.7980392c.png";